import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Grid from '@mui/material/Grid';
import { useSelector, useDispatch } from 'react-redux';
import { updateCategorias, addCategorias, setCategoria as setCategoriaRedux } from './actions/actions';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { save } from "./api-comunicado-categoria";

const useStyles = makeStyles(theme => ({
    paper: {
        display: 'flex',
        flexDirection: 'column',
        minWidth: 650,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        // marginTop: theme.spacing(1),
    },
    submit: {
        // margin: theme.spacing(3, 0, 3),
    },
    buscarBtn: {
        // margin: theme.spacing(3, 3, 3),
    },
    closeIcon: {
        marginTop: '20px',
        marginBottom: '20px',
        cursor: 'pointer'
    }
}));

export default function ComunicadoForm() {
    const classes = useStyles();
    const categoriaRedux = useSelector(state => state.comunicadoCategoria);
    const [categoria, setCategoria] = useState(categoriaRedux);
    const dispatch = useDispatch();


    useEffect(() => {
        setCategoria(categoriaRedux);
    }, [categoriaRedux]);


    const handleChange = (event) => {
        setCategoria({
            ...categoria,
            [event.target.name]: event.target.value
        })
    }

    const clickSubmit = (event) => {
        event.preventDefault();
        const eNovo = categoria.eNovo;
        save(categoria).then(data => {
            if (data) {
                toast.success("Salvo com sucesso.", {
                    position: "bottom-left"
                });
                if (eNovo) {
                    dispatch(addCategorias(data));
                } else {
                    dispatch(updateCategorias(data));
                }
                dispatch(setCategoriaRedux(data));
                setCategoria(data);
            }

        })
    }

    return (
        <div>
            <CssBaseline />
            <ToastContainer autoClose={3000} />
            <Container className={classes.paper} component={Paper} >
                <CloseIcon onClick={() => dispatch(setCategoriaRedux(null))} className={classes.closeIcon} />
                <Typography className={classes.title} variant="h5">
                    Cadastro Categoria
                </Typography>
                <Grid>
                    <form onSubmit={clickSubmit}>

                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Descrição"
                            name="descricao"
                            onChange={handleChange}
                            value={categoria && categoria.descricao ? categoria.descricao : ''}
                            slotProps={{
                                htmlInput: { maxLength: 100 }
                            }}
                        />

                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            className={classes.submit}>
                            Salvar
                        </Button>
                    </form>
                </Grid>
            </Container>
        </div>
    );
}